import { FC, HTMLAttributes, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button, Flex } from 'antd';

import NeedSourceIcon from 'assets/images/onboarding/need-source.svg?react';
import NeedVerificationIcon from 'assets/images/onboarding/need-verification.svg?react';
import SuccessIcon from 'assets/images/onboarding/success.svg?react';
import { useOnboardingSlice } from 'features/Onboarding';
import { EResultTypes } from 'features/Onboarding/model/types';
import { EMainRoutes } from 'shared/typings';

import { OnboardingText } from '../OnboardingText/OnboardingText';

interface IFinalsProps extends HTMLAttributes<HTMLDivElement> {}

export const Final: FC<IFinalsProps> = ({ className, ...props }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { resultType, createdSource, closeOnboardingModal } = useOnboardingSlice();

	const handleGoToCatalogClick = () => {
		navigate(`/${EMainRoutes.CATALOG}`);
		closeOnboardingModal();
	};

	const typesMap: Record<EResultTypes, { title: ReactNode; text: ReactNode; icon: ReactNode }> = {
		[EResultTypes.SUCCESS]: {
			title: t(`Ваша площадка создана!`),
			text: t(
				`После подтверждения владения площадкой, последняя автоматически попадет на модерацию и после ее прохождения можно подавать заявки на подключение к офферам.`,
			),
			icon: <SuccessIcon />,
		},
		[EResultTypes.NEED_VERIFICATION]: {
			title: t(`Требуется подтвердить владение площадкой`),
			text: (
				<>
					<p>
						{t(
							'{{sourceName}} создана успешно, но требуется подтвердить ее владение. Без подтверждения ее владения и прохождения модерации, вы не сможете подавать заявки на подключение к офферам. ',
							{ sourceName: createdSource?.name || '' },
						)}
					</p>
					<p>
						{t(
							'Вы сможете подтвердить площадку в любое время в разделе “Мои площадки”, нажав на кнопку "Верифицировать" в карточке площадки.',
						)}
					</p>
				</>
			),
			icon: <NeedVerificationIcon />,
		},
		[EResultTypes.NEED_SOURCE]: {
			title: t(`Вы не закончили создание площадки!`),
			text: (
				<>
					<p>
						{t(
							'Без создания площадки и подтверждения ее владения, последняя не попадет на модерацию и вы не сможете подавать заявки на подключение к офферам.',
						)}
					</p>
					<p>
						{t(
							'Вы сможете создать площадку в любое время в разделе “Каталог” либо “Мои площадки”, нажав на кнопку "Добавить площадку".',
						)}
					</p>
				</>
			),
			icon: <NeedSourceIcon />,
		},
	};

	return (
		<Flex {...props} vertical gap={24} align="center" className={className}>
			{typesMap[resultType].icon}
			<OnboardingText header={typesMap[resultType].title} text={typesMap[resultType].text} />
			<Button onClick={handleGoToCatalogClick} type={'primary'} size={'large'} htmlType={'button'}>
				{t(`Перейти в каталог`)}
			</Button>
		</Flex>
	);
};
